import { useContext } from "react";
import { Leaderboard } from "../components/leaderboard";
import { ProfileLeaderboard } from "../components/profileleaderboard";
import { Countdown } from "../components/countdown";
import { Welcome } from "../components/welcome";
import { Referral } from "../components/referral";
import { UserContext } from "../helpers/user";
import { Scribble } from "../svgcomponents/Scribble";
import { Stars } from "../svgcomponents/Stars";
import { MobileSVG } from "../svgcomponents/MobileSVG";
import { Block } from "../svgcomponents/Block";

export function HomePage() {
  const user = useContext(UserContext);
  return (
    <>
      <div className="w-full z-10">
        <Countdown />
      </div>
      <div className="visible md:invisible absolute z-0 top-48 left-0 right-0 w-screen">
        <MobileSVG />
      </div>
      <div className="invisible md:visible z-0 absolute right-0 top-3 overflow-clip">
        <Scribble />
      </div>
      <div className="flex flex-col w-11/12 md:w-10/12 z-40">
        <Welcome />
      </div>
      <div className="absolute md:left-28 top-36 invisible md:visible align-items-start">
        <Stars />
      </div>
      <div className="invisible md:visible lg:-translate-y-10 w-full align-items-start">
        <Block />
      </div>
      <div className="flex flex-col md:w-[32rem] text-3xl md:text-4xl font-bold text-center mt-32 md:mb-10 mb-7">
        Connect your werable to participate
      </div>
      {user ? (
        <div className="flex flex-col md:w-10/12 md:bg-[#F7F7F7] items-center rounded-[1rem]">
          <div className="md:w-[32rem] md:mt-20 md:mb-20 bg-white md:mx-auto flex flex-col gap-5 items-center p-4 overflow-hidden rounded-2xl">
            <ProfileLeaderboard profileuserid={user.userid} />
          </div>
        </div>
      ) : (
        <div className="flex flex-col md:w-10/12 md:bg-[#F7F7F7] items-center rounded-[1rem]">
          <div className="md:w-[32rem] md:mt-20 bg-white md:mx-auto flex flex-col gap-5 items-center p-4 overflow-hidden rounded-2xl">
            <Leaderboard />
          </div>
          <a href="/join">
            <button className="h-14 min-w-[12rem] rounded-full text-white bg-[#30A4FB] text-xl mt-12 mb-16 items-center">
              Join
            </button>
          </a>
        </div>
      )}
      {user ? (
        <div className="flex flex-col w-11/12 md:w-10/12 mt-12 md:mt-4 mb-24">
          <Referral profileuserid={user.userid}/>
        </div>
      ) : (
        <div className="flex flex-col w-11/12 md:w-10/12 mt-12 md:mt-4 mb-24">
          <Referral profileuserid={null} />
        </div>
      )}
    </>
  );
}
